export { Generalizer } from "./Generalizer";
export { useGeneralizer } from "./useGeneralizer";
